var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{class:`cv-header-nav ${_vm.carbonPrefix}--header__nav`},[_c('ul',{class:`${_vm.carbonPrefix}--header__menu-bar`,attrs:{"role":"menubar","ariaLabeldBy":_vm.ariaLabelledBy}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }